import { useGlobalLoading } from '../loadingHooks';

/**
 * V1 compatibility hook for checking if essential app data has loaded.
 * This hook uses the global loading state context to determine app readiness.
 *
 * @temporary V1 pages (BundlePage, HubSpotCreditsPage, Interstitial) use GlobalLoadingStateContext
 * which is being phased out. This hook provides explicit V1-specific loading check while V2 pages
 * use individual loading states. Remove when V1 pages are migrated to V2 patterns.
 * @expiration 2026-05-01
 * @deprecated Use individual loading states from hooks instead. V2 components should NOT use this.
 *
 * @returns {boolean} true when all essential data is loaded and app is ready
 *
 * @example
 * ```tsx
 * const isAppReady = useV1AppReady();
 * if (!isAppReady) return <LoadingSpinner />;
 * ```
 */
export const useV1AppReady = () => {
  return useGlobalLoading();
};